import { add, format, isValid } from 'date-fns';

// date-fns `format` throws "RangeError: Invalid time value" on an invalid Date,
// and `add` returns one as soon as the result leaves the representable range.
// That is reachable from the UI: <input type="date"> accepts up to 275760-09-13,
// and 275760-09-13 + 39 weeks overflows. There is no error boundary above the
// calculator, so a single throw unmounts the whole tool and leaves a blank box —
// which is what the "Invalid time value" session recording shows. Every date on
// this page is formatted through here, so guarding here covers every call site.
function safeFormat(date, dateFormat) {
  return isValid(date) ? format(date, dateFormat) : '';
}

export function formatDate(date, dateFormat = 'dd/MM/yyyy') {
  if (!date) return '';
  return safeFormat(date, dateFormat);
}

export function addWeeksAndFormat(date, weeks, dateFormat = 'dd/MM/yy') {
  if (!date) return '';
  return safeFormat(add(date, { weeks }), dateFormat);
}

export function addWeeksDaysAndFormat(date, weeks, days, dateFormat = 'dd/MM/yy') {
  if (!date) return '';
  return safeFormat(add(date, { days, weeks }), dateFormat);
}

export function addWeeks(date, weeks) {
  if (!date) return undefined;
  const result = add(date, { weeks });
  return isValid(result) ? result : undefined;
}


export function formatFrenchOrdinal(number) {
  if (number === 1) {
    return '1ère';  // Premier (feminine form)
  } else if (number === 2) {
    return '2ème';  // Deuxième
  } else {
    return `${number}ème`; // Troisième, Quatrième, etc.
  }
}

// Function to format week number in French
export function getFrenchWeekString(week) {
  if (week > 0) {
    return `Vous êtes à la ${formatFrenchOrdinal(week)} semaine`;
  } else {
    return "Sélectionnez une date pour calculer la semaine de grossesse";
  }
};
